import EventListing from './EventListing'
export default EventListing
